import React from 'react'

const About = () => {
  return (
      <>
        <div className='container my-4'>
          <div className='row'>
            <p>
                Dibrugarh University, the easternmost University in India, was established in 1965 consequent upon the 
                provisions of the Dibrugarh University Act, 1965, enacted by the Assam Legislative Assembly. It is a leading 
                research and innovation driven University that acts as a spatial slot to configure the socio-cultural dynamics
                of North East India. The University encourages myriad enterprises that harbour on a constellation of thinking,
                theorizing, and reflection.
            </p>
            <p>
                It is one of the premier institutes of North-East-India imparting computer education.Dibrugarh University 
                initiated its journey of imparting computer education by establishing a Computer Centre in 1976. The Computer
                Centre was established with the objective of creating Computer awareness among the teachers, research scholars
                and employees of the University. It started Computer education by introducing a "Six-months Certificate Course
                on Computer Programming". It also trained the employees of various banks including State Bank of India,
                Dibrugarh university Branch and helped them in computerization. In 2004, it was upgraded to the Centre
                for Computer Studies (CCS) and a "Post-Graduate Diploma in Computer Application (PGDCA)" course was started. 
                BCA was introduced in July, 2004 and MCA and BSc (IT) were introduced in January and July, 2007, respectively.
                It also trained the employees of various banks including State Bank of India, Dibrugarh university Branch
                and helped them in computerization. In 2004, it was upgraded to the Centre for Computer Studies (CCS)
                and a "Post-Graduate Diploma in Computer Application (PGDCA)" course was started. BCA was introduced in 
                July, 2004 and MCA and BSc (IT) were introduced in January and July, 2007, respectively.
            </p>
          </div>
        </div>
      </>
  )
}

export default About